import { type BlogItemT, getId, useGlobalStateObject } from 'utils';

export default function useSetBlogItem(): (item: BlogItemT) => void {
  const gs = useGlobalStateObject();

  return (blog: BlogItemT) => {
    const blogId = getId(blog);

    let list = gs.get('blog.list.data.items');
    const listIdx = list?.findIndex((item) => item.id === blogId);

    if (listIdx !== undefined && listIdx >= 0) {
      gs.set(`blog.list.data.items.${listIdx}`, blog);
    } else {
      list = [blog, ...list ?? []];
      gs.set('blog.list.data.items', list);
    }

    const mapPath = `blog.map.${blogId}.data` as const;
    if (gs.get(mapPath)) gs.set(mapPath, blog);
  };
}
